import type { BookingStatus } from '@bingo/shared';
import { useT } from '../lib/i18n';

/** Each tap: empty → C → CC → empty. Cancelling (X) and undoing it are done in the booking panel (Bruno, 17/10). */
const NEXT: Record<string, BookingStatus | null | undefined> = { none: 'C', C: 'CC', CC: null, X: undefined };
const TITLE: Record<string, string> = {
  none: 'Not contacted: tap when contacted (C)',
  C: 'Contacted: tap when confirmed (CC)',
  CC: 'Confirmed: tap to clear the status',
  X: 'Cancelled: open the booking to change it',
};

/** C / CC / X chip. Without onAdvance it only shows the status. */
export function StatusChip({ status, onAdvance, busy }: { status: BookingStatus | null; onAdvance?: (next: BookingStatus | null) => void; busy?: boolean }) {
  const t = useT();
  const key = status ?? 'none';
  const label = status ?? '–';
  const title = t(TITLE[key]!);
  const next = NEXT[key];
  if (!onAdvance || next === undefined) return <span className={`status status-${key}`} title={title}>{label}</span>;
  return (
    <button type="button" className={`status status-${key}`} title={title} aria-label={title} disabled={busy}
      onPointerDown={(e) => e.stopPropagation()} onKeyDown={(e) => e.stopPropagation()}
      onClick={(e) => { e.stopPropagation(); onAdvance(next); }}>
      {label}
    </button>
  );
}
